<template>
    <ac-modal :title="'Fee Selection'" ref="modal" :size-class="'modal-lg'">
        <fee-selection @onFeeSelected="feeSelected" ref="feeSelection" :fee-selection-instance="feeSelectionInstance">

        </fee-selection>
    </ac-modal>
</template>

<script>
    import {FeeSelectionClass} from "./FeeSelectionClass.js";
    import FeeSelection from "./FeeSelection.vue";

    export default {
        name: "FeeSelectionModal",
        components: {FeeSelection},
        props: {feeSelectionInstance: {type: [FeeSelectionClass], required: true}},
        async mounted() {
            let self = this;
            $(this.$refs.modal.$refs.modal).off('shown.bs.modal').on('shown.bs.modal', () => {
                self.$nextTick().then(() => {
                    self.$refs.feeSelection.init();
                });
            });
        },
        methods: {
            feeSelected(fee) {
                this.$emit('onFeeSelected', fee);
                this.$refs.modal.close();
            },
            async showModal() {
                this.$refs.modal.open();
            },
        }
    }
</script>

<style scoped>

</style>